const GET_THEMES_PENDING = 'GET_THEMES_PENDING';
const GET_THEMES_SUCCESS = 'GET_THEMES_SUCCESS';
const GET_THEMES_ERROR = 'GET_THEMES_ERROR';

export { GET_THEMES_PENDING, GET_THEMES_SUCCESS, GET_THEMES_ERROR };